<script>
import { mapActions } from "vuex";

/**
 * Has no display element, it's only purpose is to load
 * program data within main App when user is ready
 * and has been loaded completely
 */
export default {
  name: "TheProgramLoader",

  mounted() {
    const programId = this.$auth.user().programId;
    this.fetchProgram(programId);
    this.fetchOrganizations(programId);
  },

  methods: {
    ...mapActions("program", ["fetchProgram"]),
    ...mapActions("organizations", ["fetchOrganizations"])
  },

  render(h) {
    return h();
  }
};
</script>
